import { Check } from "lucide-react";
import Reveal from "../components/Reveal";

const OUTCOMES = [
  "Communicate clearly",
  "Establish credibility",
  "Generate leads",
  "Automate repetitive work",
  "Operate more efficiently",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-navy py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">ABOUT AT DIGITAL</p>
              <h2 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
                Technology Should Make Business Simpler.
              </h2>
              <div className="gold-hairline mt-8 h-px w-40" aria-hidden="true" />
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="text-base leading-relaxed text-slate-400">
                AT Digital combines business thinking with modern development. We aren't interested in building
                websites simply because they look impressive — we build digital systems that earn their keep.
              </p>
              <p className="mt-5 text-base leading-relaxed text-slate-400">
                Every project is designed around a simple question: will this help the business win more customers and
                run more smoothly? If the answer is no, it doesn't ship.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-9 font-mono text-[11px] font-semibold tracking-[0.24em] text-slate-500">
                WHAT OUR WORK IS BUILT TO DO
              </p>
              <ul className="mt-5 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
                {OUTCOMES.map((o) => (
                  <li key={o} className="flex items-center gap-3 text-sm font-medium text-slate-200">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full border border-gold/40">
                      <Check className="h-3.5 w-3.5 text-gold" strokeWidth={2.5} />
                    </span>
                    {o}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
